import React, { useEffect, useCallback, useState } from "react";
import { withContext } from "../../../hook/AppContext";
import "./style.scss";
import { Menu, Popover, Row, Col } from "antd";
import { Link } from "react-router-dom";
import UserLoggedIn from "./user-logged-in";
import { refreshJWTToken } from "../../../api/auth";
import { useWindowResizeMobile } from "../../../hook/ultis.hook";
import { useHistory, withRouter } from "react-router-dom";
import { CHAIN } from "../../../constants";


const Header = (props) => {
  const {
    setIsShowingLoginPopup,
    isAuthenticatedUser,
    setAuthToken,
    setRefreshToken,
    refreshToken,
    setChains,
    chains,
    logout
  } = props;
  const [currentActiveMenuItem, setCurrentActiveMenuItem] = useState("");
  const history = useHistory();
  const [isMobile] = useWindowResizeMobile(769);

  const listMenu = [
    {
      id: 0,
      title: "Main - game",
      desc: "Main gameplay",
      image: "/images/menu/play-game.svg",
      link: "https://play.monsterra.io/"
    },
    {
      id: 1,
      title: "Marketplace",
      desc: "Buy and sell your game asset",
      image: "/images/menu/marketplace.svg",
      link: "https://marketplace.monsterra.io"
    },
    {
      id:2,
      title: "DAO",
      desc: "Manage your account and join the governance",
      image: "/images/menu/dao.svg",
      link:  "https://dao.monsterra.io/"
    },
    {
      id:3,
      title: "Mini games",
      desc: "Play minigames with your assets.",
      image: "/images/menu/portal-game.svg",
      link: ""
    },
    {
      id:4,
      title: "Guild",
      desc: "Make higher benefits with your friends and fellows",
      image: "/images/menu/guild.svg",
      link:  ""
    }, 
    {
      id: 5,
      title: "Bridge",
      desc: "Transfer your tokens between supported chains",
      image: "/images/menu/bridge.svg",
      link: ""
    },
    {
      id:6,
      title: "MonsTV",
      desc: "Watch and share",
      image: "/images/menu/monstv.svg",
      link: ""
    },
    {
      id:7,
      title: "Events",
      desc: "Join to earn",
      image: "/images/menu/events.svg",
      link: "https://event.monsterra.io/"
    },
    {
      id:8,
      title: "Monsterraverse",
      desc: "The next journey...",
      image: "/images/menu/monsterraverse.svg",
      link: ""
    },
    {
      id:9,
      title: "Support Center",
      desc: "Share your feedback or track your support ticket.",
      image: "/images/menu/support.svg",
      link: "https://support.monsterra.io/"
    },
    {
      id:10,
      title: "Guideline",
      desc: "Detailed Instructions",
      image: "/images/menu/guideline.svg",
      link:  "https://docs.monsterra.io/"
    },
    {
      id:11,
      title: "Homepage",
      desc: "Landing page",
      image: "/images/menu/homepage.svg",
      link: "https://monsterra.io"

    },
  ]

  useEffect(async () => {
    try {
      setChains([CHAIN])
      if (isAuthenticatedUser) {
        const res = await refreshJWTToken({
          refresh_token: refreshToken,
        });
        setAuthToken(res.access_token);
        setRefreshToken(res.refresh_token);
      }}
    catch(er) {
      logout()
    }
  }, []);

  useEffect(() => {
     if (history.location.pathname.includes("vesting")) {
      setCurrentActiveMenuItem("vesting");
    }
  }, [history.location.pathname]);

  const content = () => (
    <div className="popover-menu-container">
    <Row className="menu-container">
      {listMenu.map((el) => (
        <Col key={el.id}  sm={8} xs={24} className={!el.link ? "disabled-item" : null}>
          <a href={el.link ? el.link : null} target="_blank">
            <Row className="menu-item">
              <Col>
                <img src={el.image}/>
              </Col>
              <Col>
                <div className="item-title">{el.title}</div>
                {el.desc}
              </Col>
            </Row>
          </a>
        </Col>
      ))}
    </Row>
    </div>
  )

  const onChangeMenu = (e) => {
    setCurrentActiveMenuItem(e.key);
  };

  return (
    <>
      <div className="header">
        <Menu
          mode="horizontal"
          className="header-menu"
          selectedKeys={[currentActiveMenuItem]}
          defaultSelectedKeys={[currentActiveMenuItem]}
          onClick={onChangeMenu}
        >
          <Menu.Item key="vesting" className="">
            <Link to="/">
              <img className="img-logo" src="/images/logo-game.png" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Popover placement="bottomRight" content={content} trigger="click" className="popover-menu">
              <div >
                <svg width="74" height="70" viewBox="0 0 74 70" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6704 24.5H16.7704C14.5904 24.5 13.4404 25.65 13.4404 27.83V29.73C13.4404 31.91 14.5904 33.06 16.7704 33.06H18.6704C20.8504 33.06 22.0004 31.91 22.0004 29.73V27.83C22.0004 25.65 20.8504 24.5 18.6704 24.5Z" fill="#A4A5AF"></path><path d="M7.24 35.9299H5.34C3.15 35.9299 2 37.0799 2 39.2599V41.1599C2 43.3499 3.15 44.4999 5.33 44.4999H7.23C9.41 44.4999 10.56 43.3499 10.56 41.1699V39.2699C10.57 37.0799 9.42 35.9299 7.24 35.9299Z" fill="#A4A5AF"></path><path d="M6.29 33.08C8.6593 33.08 10.58 31.1593 10.58 28.79C10.58 26.4207 8.6593 24.5 6.29 24.5C3.9207 24.5 2 26.4207 2 28.79C2 31.1593 3.9207 33.08 6.29 33.08Z" fill="#A4A5AF"></path><path d="M17.7099 44.4999C20.0792 44.4999 21.9999 42.5792 21.9999 40.2099C21.9999 37.8406 20.0792 35.9199 17.7099 35.9199C15.3406 35.9199 13.4199 37.8406 13.4199 40.2099C13.4199 42.5792 15.3406 44.4999 17.7099 44.4999Z" fill="#A4A5AF"></path><g opacity="0.7"><path d="M41.9465 31.9534H37.7932H34.0532C33.4132 31.9534 33.0932 32.7267 33.5465 33.18L36.9998 36.6334C37.5532 37.1867 38.4532 37.1867 39.0065 36.6334L40.3198 35.32L42.4598 33.18C42.9065 32.7267 42.5865 31.9534 41.9465 31.9534Z" fill="#A4A5AF"></path></g></svg>
              </div>
            </Popover>
          </Menu.Item>
          {!isMobile && <Menu.Item key="vesting" className="mr-auto">
            <Link to="/vesting">Vesting</Link>
          </Menu.Item>}
          {isAuthenticatedUser ? (
            <Menu.Item className="user-logged-in">
              <UserLoggedIn />
            </Menu.Item>
          ) : (
            <Menu.Item className=" user-logged-in">
              <Link to="/connect-wallet" className="connect-wallet">
                <img src="/images/connect-wallet.svg"/> Connect Wallet
              </Link>
            </Menu.Item>
          )}
        </Menu>
        {isMobile &&<Menu 
          mode="horizontal"
          className="header-menu header-mobile"
          selectedKeys={[currentActiveMenuItem]}
          defaultSelectedKeys={[currentActiveMenuItem]}
          onClick={onChangeMenu}
          popupClassName="menu-popup"
        >
          <Menu.Item key="vesting" className="mr-auto">
            <Link to="/vesting">Vesting</Link>
          </Menu.Item>
          {/* <Menu.Item  className="mr-auto">
            <a target="_blank" href="https://marketplace.monsterra.io/">Marketplace</a>
          </Menu.Item>
          <Menu.Item className="mr-auto">
            <a target="_blank" href="https://marketplace.monsterra.io/">Landing Page</a>
          </Menu.Item> */}
        </Menu>}
      </div>
    </>
  );
};

export default withContext(withRouter(Header));
